import { Divider, Typography } from '@mui/material';
import { Stack, SxProps, Theme } from '@mui/system';
import React from 'react';
import I18n from '../../../../i18n/I18n';
import { failedToastMessage } from '../../../../utils/commonUtils';
import { useReviewApprovalContext } from '../../hooks/useReviewApprovalContext';
import ApprovalApproversView from './ApprovalApproversView';
import ApprovalAttachmentsView from './ApprovalAttachmentsView';
import ApprovalNotesView from './ApprovalNotesView';
import ApprovalNotifyContactsView from './ApprovalNotifyContactsView';
import ApprovalSummaryView from './ApprovalSummaryView';

export interface ApprovalViewProps {
    withCollapsibleSections?: boolean;
    sx?: SxProps<Theme>;
}

export default function ApprovalView({ withCollapsibleSections = false, sx }: ApprovalViewProps) {
    const { approvalId, errorFetchingApprovalData, throwOnError } = useReviewApprovalContext();

    if (!approvalId) {
        return (
            <Typography
                color="textSecondary"
                sx={{ py: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <I18n token="approval.provide.approvalId" />
            </Typography>
        );
    }

    if (errorFetchingApprovalData) {
        if (!throwOnError) {
            failedToastMessage('approval.data.fetch.error');
        }

        return (
            <Typography color="error" sx={{ py: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <I18n token="approval.data.fetch.error" />
            </Typography>
        );
    }

    return (
        <Stack spacing={1.5} divider={<Divider orientation="horizontal" flexItem sx={sx} />}>
            <ApprovalSummaryView isCollapsable={withCollapsibleSections} defaultCollapsed={false} />
            <ApprovalAttachmentsView isCollapsable={withCollapsibleSections} defaultCollapsed={false} />
            <ApprovalApproversView isCollapsable={withCollapsibleSections} defaultCollapsed={false} />
            <ApprovalNotifyContactsView isCollapsable={withCollapsibleSections} defaultCollapsed={false} />
            <ApprovalNotesView isCollapsable={withCollapsibleSections} defaultCollapsed={false} />
        </Stack>
    );
}
